<script setup>
import { useSlots } from "vue";
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";

const { smallerOrEqual } = useBreakpoints(breakpointsBootstrapV5);

const isMobileView = smallerOrEqual("xl");

const slots = useSlots();
</script>

<template>
  <div
    class="settings-layout"
    :class="{ 'settings-layout--mobile': isMobileView }"
  >
    <div
      v-if="slots['page-header']"
      class="settings-layout__page-header"
    >
      <slot name="page-header" />
    </div>

    <h3 class="settings-layout__page-title">
      <slot name="page-title" />
    </h3>

    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;

.settings-layout {
  $self: &;

  padding: spacing.$l;

  &__page-header {
    margin-bottom: spacing.$s;
  }

  &__page-title {
    font-weight: typography.$font-weight-bold;
    margin-bottom: spacing.$s;
  }

  &--mobile {
    padding: spacing.$xs;
  }
}
</style>
